import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Cookie, X } from 'lucide-react';

const CONSENT_KEY = 'dg_cookie_consent';

const CookieConsent: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem(CONSENT_KEY, 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] p-3 md:p-4 animate-slide-in-up">
      <div className="max-w-3xl mx-auto glass-panel rounded-2xl p-4 md:p-5 flex flex-col sm:flex-row items-start sm:items-center gap-3 shadow-2xl">
        <div className="flex items-start gap-3 flex-1">
          <Cookie size={24} className="text-accent shrink-0 mt-0.5" />
          <div>
            <p className="text-sm text-foreground font-semibold" style={{ fontFamily: 'Fredoka, sans-serif' }}>
              We use cookies 🍪
            </p>
            <p className="text-xs text-muted-foreground mt-1 leading-relaxed">
              We use cookies to improve your experience, analyze traffic, and show relevant ads.
              By clicking "Accept", you consent to our use of cookies.{' '}
              <Link to="/privacy-policy" className="text-primary underline hover:text-primary/80">
                Privacy Policy
              </Link>
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2 shrink-0 w-full sm:w-auto">
          <button
            onClick={decline}
            className="flex-1 sm:flex-none px-4 py-2 rounded-xl text-xs font-bold text-muted-foreground bg-muted hover:bg-muted/80 transition-colors"
            style={{ fontFamily: 'Fredoka, sans-serif' }}
          >
            Decline
          </button>
          <button
            onClick={accept}
            className="flex-1 sm:flex-none btn-game-primary px-5 py-2 rounded-xl text-xs"
          >
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
